// ====================================================
// Sets up boxes on the review page
(function PageWholesale() {

  // Get URL for google script to modify spreadsheet
  const SCRIPT_URL = "https://script.google.com/macros/s/AKfycbxPXKedoDltSFzl-1aNDLKTy-hTO0a6faiHjzn0fKq0h2avbGzXkuBXXct3DyLy7NfO/exec"
  
  let isSubmitting = false;

  const submitForm = document.getElementById('submit-form');
  submitForm.onclick = function(evt) {
    
    // Skip sending data if name or email is bad
    if (!validateRequiredFields()) {
      return true;
    }
    
    evt.preventDefault();

    if (isSubmitting) {
      return false;
    }

    // Set loading flag to avoid spamming button
    isSubmitting = true;

    // Store all inputs' values into a single object
    const formData = constructFormData();

    // Display AJAX loader over submit button
    updateDisplay('loading');
    
    const params = new URLSearchParams(formData).toString()
    
    fetch(SCRIPT_URL + "?" + params,{ redirect: "follow",mode: "no-cors"})
    .then(() => {
        
		updateDisplay("done");
    }).catch((error) => {
        console.error(error);
		window.alert("There was an error");
    })

  }

  function validateRequiredFields() {
    const email = $('#email').val();
    const emailValid = email !== '' && email.includes('@');
    return $('#first-name').val() !== '' && $('#last-name') !== '' && emailValid;
  }

  function constructFormData() {
    return {
      'name': $('#first-name').val() + ' ' + $('#last-name').val(),
      'email': $('#email').val(),
      'company': $('#company').val(),
      'phone_1': constructPhoneNumber('shipping', 'tel'),
      'address_1': constructAddress("shipping"),
      'primary_business_type': $('#primary-business-type').val(),
      'num_of_locations': $('#num-of-locations').val(),
      'num_of_carriers': $('#num-of-carriers').val(),
      'website_url': $('#website-url').val(),
      'sales_venues': $('#sales-venues').val(),
      'online_marketing': $('#online-marketing').val(),
      'sell_online': $('#sell-online').val(),
      'years_established': $('#years-established').val(),
      'other_brands': $('#other-brands').val(),
      'other_products': $('#other-products').val(),
      'maintain_rrp': $('#maintain-rrp').val(),
      'tax_number': $('#tax-number').val()
    };
  }

  function constructPhoneNumber(prefix, telOrFax) {
    var data = [
      $('#' + prefix + '-' + telOrFax + '-country').val(),
      $('#' + prefix + '-' + telOrFax + '-0').val(),
      $('#' + prefix + '-' + telOrFax + '-1').val(),
      $('#' + prefix + '-' + telOrFax + '-2').val(),
    ];
    return data[0] + ' (' + data[1] + ') ' + data[2] + '-' + data[3];
  }

  function constructAddress(prefix) {
    var data = [
      $('#' + prefix + '-address-0').val(),
      $('#' + prefix + '-address-1').val(),
      $('#' + prefix + '-city').val(),
      $('#' + prefix + '-province').val(),
      $('#' + prefix + '-zip-code').val(),
      $('#' + prefix + '-country').val()
    ];
    return data[0] + ', ' + data[1] + ', ' + data[2] + ', ' + data[3] + ' ' + data[4] + ' ' + data[5];
  }

  function updateDisplay(state) {
    var loader = $('.wsale_ajax-loader');
    var submit = $('#submit-form');

    switch (state) {
      case 'loading':
        submit.toggleClass('wsale_submit-form-disabled', true);
        loader.css('opacity', '1');
        loader.css('z-index', '9999');
        break;

      case 'done':
        submit.toggleClass('wsale_submit-form-disabled', false);
        window.location = "/pages/submitted-thank-you/";
        loader.css('opacity', '0');
        loader.css('z-index', '-1');
        break;
    }
  }

})();
